import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class KioskSettingsService {
  api =  environment.baseUrl + "configuration";

  constructor(private httpClient: HttpClient) { }

  getSetting(param: string):Observable<any>{
    return this.httpClient.get(this.api+"/getByParameter/" + param);
  }

  /**
   * get tax by order type
   * @param orderTypeId
   * @returns 
   */
  getTaxByDeliveryMethod(orderTypeId: number): Observable<any> {
    return this.httpClient.get(`${environment.baseUrl}orderTypes/tax/${orderTypeId}`);
  }

  /**Add commentMore actions
   * get tax included cofig
   * @param storeId
   * @returns 
   */
  getTaxIncludedConfig(storeId: number) {
    return this.httpClient.get(`${this.api}/getByParameter/TaxIncluded/${storeId}`);
  }

}
